import KitFadeView from '@omni/kit/components/KitFadeView';
import BorderRadius from '@omni/kit/theming/BorderRadius';
import Colors from '@omni/kit/theming/Colors';
import { transparentHexColor } from '@omni/kit/utilities/utilities';
import React, { ReactElement } from 'react';
import { StyleSheet, View } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';

export type ControlsBackgroundType = 'gradient' | 'solid';

export interface ControlsBackgroundProps {
  isVisible?: boolean;
  type?: ControlsBackgroundType;
}

export default function ControlsBackground({
  isVisible = true,
  type,
}: ControlsBackgroundProps): ReactElement {
  let background: ReactElement;

  switch (type) {
    case 'gradient':
      background = (
        <LinearGradient
          colors={[
            transparentHexColor(Colors.N1000, 50),
            transparentHexColor(Colors.N1000, 30),
          ]}
          style={StyleSheet.absoluteFill}
        />
      );
      break;

    case 'solid':
    default:
      background = <View style={styles.solidBackground} />;
      break;
  }

  return (
    <KitFadeView show={isVisible} style={StyleSheet.absoluteFill}>
      {background}
    </KitFadeView>
  );
}

const styles = StyleSheet.create({
  solidBackground: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: transparentHexColor(Colors.N1000, 50),
    borderRadius: BorderRadius.m,
  },
});
